import axios from 'axios';
import { BASE_URL } from "../config-global.jsx";
import { setSession } from "@/utils/auth.js";
import { handleError } from "@/services/errorHandler.js";
import { AUTH_BASE_PATH } from '@/consts/index.js'

const axiosInstance = axios.create({ baseURL: BASE_URL });

export const AUTH_HEADER_KEY = "jwt"
export const ACCOUNT_HEADER_KEY = "x-account-id"
export const SPACE_HEADER_KEY = "x-space-id"

export const setAxiosAuth = (accessToken) => {
    axiosInstance.defaults.headers.common[AUTH_HEADER_KEY] = accessToken
}

export const setAxiosAccountContext = (accountId) => {
    axiosInstance.defaults.headers.common[ACCOUNT_HEADER_KEY] = accountId
}

export const setAxiosSpaceContext = (spaceId) => {
    axiosInstance.defaults.headers.common[SPACE_HEADER_KEY] = spaceId
}

export  const removeAxiosAuth = () => {
    delete axiosInstance.defaults.headers.common[AUTH_HEADER_KEY];
}

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
      // in case we get 401 from the server, we logout the user completely with the basic default alert message (except for the case of wrong credentials which mean the user try to login with wrong credentials, we want to handle it differently and not redirect him)
      if (error.response?.status === 401 && error.response?.data?.name !== 'wrong-credentials') {
          handleError(error.response)
          setSession()
          alert('Unauthenticated, Please log in again')
          window.location.href = window.location.origin + AUTH_BASE_PATH
          return
      }
      return Promise.reject((error.response && error.response.data) || 'Something went wrong')
  }
);




export default axiosInstance;
